import * as React from 'react'
import styled from 'styled-components'
import { colors, devices } from '../../styleConstants'
import { Dialog } from '../common/Dialog'
import { ReservationState, Modal } from './useReservationState'
import { Mode, useEditAttributeState } from './useEditAttributeState'
import { I18nCatalogue } from '../../i18n/reservation/types'
import { getPreferredLanguage } from '../../i18n'
import { HairStylist } from '../../types/hairStylist'
import { Button } from '../common/Button'
import { Reserve } from '../../types/reservation'
import moment from 'moment'

interface Props {
  readonly catalogue: I18nCatalogue
  readonly pageState: ReservationState
  readonly stylist: HairStylist
  readonly onEdited?: () => void
}

interface State {
  readonly selectedDateTime: string
  readonly selectedSpotNumber: string
}

export function ConfirmReservation({ catalogue, pageState, stylist }: Props) {
  const notificationId = `confirm-reservation-` + pageState.selectedTime
  const { actionState, onClose } = useEditAttributeState(pageState, notificationId, '')

  const daysAgo = moment(pageState.selectedTime).diff(moment(pageState.reservedSpot!.releaseTime), 'days')

  const selectedDateTime = pageState.selectedTime
  const selectedSpotNumber = pageState.reservedSpot!.spots.toString()
  const reserveCount = pageState.reservedSpot!.reserves.length
  const [state] = React.useState<State>({ selectedDateTime, selectedSpotNumber })
  const dateTimePickerLocale = getPreferredLanguage() == 'ja' ? 'ja' : 'en'

  function getSalonNameById(salonId: string) {
    let salonName = ''
    stylist.salons.map(salon => {
      if (salon.id.toString() == salonId) {
        salonName = salon.name
      }
    })

    return salonName
  }

  async function clickedEditButton() {
    /**Open Reservation Edit Modal */
    pageState.setState({
      modal: Modal.Edit,
      selectedTime: pageState.selectedTime,
      reservedSpot: pageState.reservedSpot,
      cancelReservation: null,
      spots: [],
      isMobile: false,
    })
  }

  async function clickedCancelButton(cancelReservation: Reserve) {
    /**Open Reservation Cancel Modal */
    pageState.setState({
      modal: Modal.Cancel,
      selectedTime: pageState.selectedTime,
      reservedSpot: pageState.reservedSpot,
      cancelReservation: cancelReservation,
      spots: [],
      isMobile: false,
    })
  }

  return (
    <Dialog
      onClose={onClose}
      title={catalogue.reservationConfirm.title}
      data-test="Confirm-reservation-of-modal"
      actions={[
        {
          label: catalogue.close,
          look: 'white',
        },
      ]}>
      {actionState.mode === Mode.Failed && <ErrorMessage>{actionState.message}</ErrorMessage>}
      <DialogItem>
        <span style={{ float: 'left', marginRight: '18px' }}>{catalogue.reservationDateTime}:</span>
        <span>{pageState.selectedTime}</span>
      </DialogItem>
      <DialogItem>
        <span style={{ marginRight: '18px' }}>{catalogue.salon}:</span>
        <span>{getSalonNameById(pageState.reservedSpot!.salonId)}</span>
      </DialogItem>
      <DialogItem>
        <span style={{ marginRight: '18px' }}>{catalogue.reservablePeople}:</span>
        <span>{state.selectedSpotNumber}</span>
      </DialogItem>
      <DialogItem>
        <span style={{ float: 'left' }}>
          {catalogue.reservationReleaseDate}: {daysAgo}
          {catalogue.daysAgo}
        </span>
      </DialogItem>
      {/** show reserved users */}
      {reserveCount > 0 && (
        <DialogItem>
          <span style={{ float: 'left', paddingTop: '5px' }}>{catalogue.reservedUser}:</span>
          <ReserveList>
            {pageState.reservedSpot!.reserves.map(reservation => {
              return (
                <ReservedUserItem>
                  <ReserveInfo>
                    {reservation.name}
                    {dateTimePickerLocale == 'ja' && <span>様</span>}
                    <br />
                    TEL: {reservation.phoneNumber}
                    <br />
                    MENU: {reservation.menuName}
                    <div style={{ marginTop: 10 }}>
                      メッセージ:
                      <Message>{reservation.message}</Message>
                    </div>
                  </ReserveInfo>
                  <Button look={'primary'} style={{ float: 'right' }} onClick={() => clickedCancelButton(reservation)}>
                    <span style={{ fontSize: '10px' }}>{catalogue.cancel}</span>
                  </Button>
                </ReservedUserItem>
              )
            })}
          </ReserveList>
        </DialogItem>
      )}
      <DialogItem>
        <Button look={'primary'} onClick={clickedEditButton}>
          <span>{catalogue.edit}</span>
        </Button>
      </DialogItem>
    </Dialog>
  )
}
const DialogItem = styled.div`
  margin: 18px;
  min-height: 36px;
`

const ErrorMessage = styled.div`
  font-weight: bold;
  color: ${colors.error};
`

const ReserveList = styled.ul`
  display: table;
  list-style: none;
  @media ${devices.mobile} {
    padding: 0;
  }
`

const ReservedUserItem = styled.li`
  margin: 6px;
`

const ReserveInfo = styled.div`
  display: inline-block;
  width: 300px;
  @media ${devices.mobile} {
    font-size: 14px;
    width: 180px;
  }
`

const Message = styled.div`
  white-space: pre-line;
`
